import * as tslib_1 from "tslib";
import MailListContent from './MailListContent';
import { logUsage } from 'owa-analytics';
import { logMountingPerformance } from 'owa-analytics';
import { clearFilter } from 'owa-mail-filter-actions';
import { resetFocus } from 'owa-mail-focus-manager';
import * as MailModuleAutoFocusManager from 'owa-mail-focus-manager/lib/mailModuleAutoFocusManager';
import { hideMailItemContextMenu } from 'owa-mail-list-actions/lib/actions/itemContextMenuActions';
import { MailListItemContextMenu } from 'owa-mail-list-context-menu';
import { MailListEmptyState } from 'owa-mail-list-empty-state';
import { listViewStore } from 'owa-mail-list-store';
import datapoints from 'owa-mail-list-store/lib/datapoints';
import store from 'owa-mail-store/lib/store/Store';
import getMailListLoadState from 'owa-mail-store/lib/utils/getMailListLoadState';
import { loadTableViewFromTableQuery } from 'owa-mail-table-loading-actions';
import { trace } from 'owa-trace';
import * as React from 'react';
import { reactive } from 'satcheljs/lib/legacy/react';
var styles = require('./MailList.scss');
var MailList = /** @class */ (function (_super) {
    tslib_1.__extends(MailList, _super);
    function MailList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * Callback when the list view gains focus from the focus manager
         */
        _this.trySetFocus = function () {
            // This can be null when component is not fully mounted
            if (!_this.listViewContainer) {
                return false;
            }
            var currentShowListPane = store.mailModule.showListPane;
            if (currentShowListPane) {
                // mailListViewContent can be null until content gets fully mounted
                // when 1) user switches folder or 2) OWA reloads
                if (_this.mailListContent) {
                    // Focus on content if it exists
                    return _this.mailListContent.trySetFocus();
                }
                else {
                    _this.listViewContainer.focus();
                    return true;
                }
            }
            else {
                // Let FocusManager handle the job when listview is hidden
                return false;
            }
        };
        /**
         * Returns flag indicating whether the document active element is contained within this MailList
         */
        _this.isFocusInMailList = function () {
            return _this.listViewContainer && _this.listViewContainer.contains(document.activeElement);
        };
        _this.isFocusOnMailList = function () {
            return _this.listViewContainer && _this.listViewContainer == document.activeElement;
        };
        /**
         * Reload the default list view for selected folder id
         */
        _this.reloadTable = function (actionSource) {
            var tableView = listViewStore.tableViews.get(_this.props.tableViewId);
            loadTableViewFromTableQuery(tableView.tableQuery, null /* loadTableViewDatapoint */, actionSource);
            // Log that retry was clicked
            logUsage(datapoints.mailListRetryClicked.datapoint.name);
        };
        _this.setlistViewContainerRef = function (ref) {
            _this.listViewContainer = ref;
        };
        _this.onDragOver = function (evt) {
            /* We need preventDefault so that the circle-slash ghost icon does not show and to prevent redirection in firefox */
            evt.preventDefault();
        };
        _this.onDrop = function (evt) {
            /* We need preventDefault to prevent redirection in firefox */
            evt.preventDefault();
        };
        /**
         * Called when mail list scroll
         */
        _this.onMailListScroll = function (ev) {
            // If context menu was open, dismiss the context menu
            if (_this.props.itemContextMenuState) {
                _this.dismissContextMenu(ev);
            }
        };
        /**
         * Dismiss the context menu and reset focus
         */
        _this.dismissContextMenu = function (ev) {
            hideMailItemContextMenu();
            resetFocus();
        };
        return _this;
    }
    MailList.prototype.componentDidMount = function () {
        MailModuleAutoFocusManager.registerComponent(MailModuleAutoFocusManager.FocusComponent.MailList, this.trySetFocus);
        if (!this.listViewContainer) {
            trace.error('listViewContainer should not be null');
        }
    };
    MailList.prototype.componentWillUnmount = function () {
        MailModuleAutoFocusManager.unregisterComponent(MailModuleAutoFocusManager.FocusComponent.MailList);
    };
    MailList.prototype.render = function () {
        var _this = this;
        var mailListViewState = getMailListLoadState();
        var listViewContent;
        // Render when table is Loaded.
        if (mailListViewState == 0 /* Loaded */) {
            listViewContent = (React.createElement("div", { onDragOver: this.onDragOver, onDrop: this.onDrop, className: styles.container },
                React.createElement(MailListContent, { ref: function (ref) { return (_this.mailListContent = ref); }, isFocusOnMailList: this.isFocusOnMailList, isFocusInMailList: this.isFocusInMailList, tableViewId: this.props.tableViewId, onScroll: this.onMailListScroll }),
                this.renderItemContextMenu()));
        }
        else {
            listViewContent = (React.createElement(MailListEmptyState, { tableViewId: this.props.tableViewId, stateType: mailListViewState, clearFilterCommand: clearFilter, reloadCommand: this.reloadTable }));
        }
        return (React.createElement("div", { tabIndex: -1, ref: this.setlistViewContainerRef, className: styles.wrapperDiv }, listViewContent));
    };
    /**
     * Renders the mail list item context menu by initiating the itemContextMenuState state in store
     */
    MailList.prototype.renderItemContextMenu = function () {
        var itemContextMenuState = this.props.itemContextMenuState;
        return (itemContextMenuState && (React.createElement(MailListItemContextMenu, { anchorPoint: itemContextMenuState.anchor, menuType: itemContextMenuState.menuType, menuSource: itemContextMenuState.menuSource, onDismiss: this.dismissContextMenu, tableViewId: this.props.tableViewId })));
    };
    MailList = tslib_1.__decorate([
        reactive({
            itemContextMenuState: function () { return listViewStore.itemContextMenuState; },
        }),
        logMountingPerformance('MailList')
    ], MailList);
    return MailList;
}(React.Component));
export default MailList;
//# sourceMappingURL=MailList.js.map